import { memo } from 'react';
import { Letter } from './types';

function LetterItem({ letter }: Letter) {
  return (
    <span>{letter}</span>
  );
}

export default memo(LetterItem);